import { faEnvelope, faUserDoctor } from '@fortawesome/pro-light-svg-icons';
import { faWhatsapp } from '@fortawesome/free-brands-svg-icons';
import { DataTestIdEnum } from '@medprev-web-app/datatestid';

import { Typography } from '@/components/ui/typography/typography.component';
import { TypographyVariant } from '@/components/ui/typography/typography.type';
import { Card } from '@/components/ui/card.component';
import { Icon } from '@/components/ui/icon.component';
import { styleFaq } from '@/app/(main)/(pages)/(institucional)/preciso-de-ajuda/_consts/style-faq.consts';
import { Button } from '@/components/ui/button/button.component';
import { Link } from '@/components/ui/link/link.component';
import { partnerSacEmail } from '@/utils/consts/partner.consts';
import { phoneProfessionalSac } from '@/utils/consts/sac.consts';
import { useWhatsappLinkSimple } from '@/hooks/use-whatsapp/use-whatsapp-link-simple.hook';
import { partnerSacWhatsappMessage } from '@/utils/consts/cta-whatsapp-messages.consts';
import { AnalyticsEnum } from '@/types/enums/analytics/analytics.enum';

export const FaqSupportProfessionalsCard = () => {
  const { buttonSmFit } = styleFaq();
  const { url } = useWhatsappLinkSimple(
    phoneProfessionalSac,
    partnerSacWhatsappMessage,
  );

  return (
    <Card
      className="flex flex-col gap-4 p-5"
      data-testid={DataTestIdEnum.FAQ_SUPPORT_PROFESSIONALS_CARD}
    >
      <div className="inline-flex">
        <Icon
          className="text-blue-600 self-center items-center w-6 h-6"
          icon={faUserDoctor}
          size="lg"
        />
        <Typography
          className="font-semibold ml-3"
          variant={TypographyVariant.MEDIUM_SUBTITLE}
        >
          Atendimento para profissional de saúde
        </Typography>
      </div>
      <Typography variant={TypographyVariant.BODY_TEXT}>
        Para suporte, dúvidas, reclamações ou sugestões referentes à nossa
        parceria, você pode contatar diretamente nosso time de atendimento por
        e-mail ou WhatsApp.
      </Typography>

      <div className="flex flex-col sm:flex-row gap-3">
        <Button
          data-testid={DataTestIdEnum.FAQ_SUPPORT_PROFESSIONALS_WHATSAPP_SAC}
          asChild
          className={buttonSmFit()}
          startIcon={faWhatsapp}
          variant="secondary"
        >
          <Link prefetch={false} href={url} target="_blank" data-analytics-event={AnalyticsEnum.CLICK_FAQ_WHATSAPP_PARTNER_SAC_BUTTON}>
            WhatsApp do SAC
          </Link>
        </Button>
        <Button
          asChild
          className={buttonSmFit()}
          startIcon={faEnvelope}
          variant="secondary"
        >
          <Link
            prefetch={false}
            data-testid={DataTestIdEnum.FAQ_EMAIL_SAC_BUTTON}
            href={partnerSacEmail}
            target="_blank"
            data-analytics-event={AnalyticsEnum.CLICK_FAQ_PROFESSIONAL_SAC_EMAIL_BUTTON}
          >
            E-mail do SAC
          </Link>
        </Button>
      </div>
    </Card>
  );
};
